import React from "react"

export default ({ text }) => <p className="text-danger mb-2" style={{ fontSize: "0.85em" }}>
    {text}
</p>